import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail, ctx) {
  const status = ctx?.status;
  if (detail == null) {
    if (ctx?.network) return "Server non raggiungibile: nessuna risposta ricevuta (la richiesta potrebbe non essere arrivata).";
    if (status) return `Errore HTTP ${status}${ctx.statusText ? ` ${ctx.statusText}` : ""}: il server non ha fornito dettagli.`;
    return "Errore sconosciuto: nessun dettaglio disponibile dal server.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? `${Array.isArray(e.loc) ? e.loc.join(".") + ": " : ""}${e.msg}` : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof detail === "object") {
    const parts = [];
    if (status) parts.push(`HTTP ${status}`);
    if (detail.code) parts.push(String(detail.code));
    if (detail.message || detail.msg) parts.push(String(detail.message || detail.msg));
    if (detail.field) parts.push(`campo: ${detail.field}`);
    if (detail.received !== undefined && detail.received !== null) parts.push(`ricevuto: ${typeof detail.received === "string" ? detail.received : JSON.stringify(detail.received)}`);
    if (detail.expected !== undefined) parts.push(`atteso: ${JSON.stringify(detail.expected)}`);
    if (detail.allowed) parts.push(`ammessi: ${[].concat(detail.allowed).join(", ")}`);
    if (detail.keys) parts.push(`chiavi: ${[].concat(detail.keys).join(", ")}`);
    if (detail.missing) parts.push(`mancanti: ${[].concat(detail.missing).join(" · ")}`);
    if (Array.isArray(detail.mismatches) && detail.mismatches.length)
      parts.push(`derive: ${detail.mismatches.map((m) => m.field).join(", ")}`);
    if (Array.isArray(detail.drift_fields) && detail.drift_fields.length)
      parts.push(`derive: ${detail.drift_fields.join(", ")}`);
    return parts.length ? parts.join(" — ") : JSON.stringify(detail);
  }
  return String(detail);
}

// Errore axios -> {status, code, message} sicuro e mai generico
export function describeApiError(e) {
  const status = e?.response?.status ?? null;
  const detail = e?.response?.data?.detail;
  const code = detail && typeof detail === "object" ? detail.code || null : null;
  const message = formatApiErrorDetail(detail, {
    status, statusText: e?.response?.statusText,
    network: !e?.response && !!e?.request,
  });
  return { status, code, message, detail };
}

export const fmtMoney = (n, currency = "EUR") => {
  const sym = { EUR: "€", USD: "$", GBP: "£" }[currency] || currency;
  return `${sym} ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
export const fmtNum = (n, digits = 2) =>
  Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: digits });
